import { unwrapResult } from '@reduxjs/toolkit';
import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import querystring from 'querystring';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store';
import { registerWithShopifyCredentials } from 'store/userDetailsSlice';
import { getStoreNameFromShopifyUrl } from 'utils/helpers';
import { useQuery } from 'utils/useQuery';
import { QueryParam } from './types';

export default function Register() {
  const passwordFieldRef = useRef(null);
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [errorMsg, setErrorMsg] = useState('');

  const query = useQuery();
  const state = query.get(QueryParam.STATE);
  const shop = query.get(QueryParam.SHOP);

  function handleOnSubmit(event: any) {
    event.preventDefault();

    if (!!!state) {
      toast.error(
        'Installation failed, please contact our team for assistance - error: state is a required property',
        { autoClose: 15000 }
      );
      return;
    }
    const { email, password, name, referral } = event.target;

    const registerPayload = {
      email: email.value.toLowerCase(),
      password: password.value,
      name: name.value,
      state,
      referral_code: referral.value,
    };
    setLoading(true);
    dispatch(registerWithShopifyCredentials(registerPayload))
      .then(unwrapResult)
      .then(() => {
        setLoading(false);
        history.replace({
          pathname: '/dashboard/welcome',
          search: querystring.stringify({
            store_name: getStoreNameFromShopifyUrl(shop as string),
          }),
        });
      })
      .catch((err) => {
        setLoading(false);
        if (err.message === '403') {
          toast.error('User already exist. Please log in', {
            autoClose: 15000,
          });
          return;
        }

        toast.error(
          'Installation failed, please contact our team for assistance',
          { autoClose: 15000 }
        );
      });
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener(
        'invalid',
        () => {
          input.classList.add(
            'focus:ring-segments-at-risk',
            'focus:border-segments-at-risk'
          );
        },
        false
      );
      input.addEventListener('keyup', (e) => {
        const capslock = e.getModifierState?.('CapsLock');
        if (capslock) {
          setErrorMsg('Note : Your Capslock key is currently turned on');
        } else {
          setErrorMsg('');
        }
      });
    });
  }, []);

  return (
    <div className="mt-8">
      <form onSubmit={handleOnSubmit}>
        <div>
          <label htmlFor="name" className="block text-sm font-bold">
            Name
          </label>
          <TextField
            // @ts-ignore
            name="name"
            type="text"
            placeholder="Required"
            size="small"
            required
          />
        </div>

        <div className="mt-4">
          <label htmlFor="email" className="block text-sm font-bold">
            Email
          </label>
          <TextField
            // @ts-ignore
            name="email"
            type="email"
            placeholder="Required"
            required
          />
          {errorMsg && (
            <p className="text-segments-13px text-segments-at-risk">
              {errorMsg}
            </p>
          )}
        </div>
        <div className="mt-4">
          <label htmlFor="password" className="block text-sm font-bold">
            Password
          </label>
          <TextField
            ref={passwordFieldRef}
            // @ts-ignore
            name="password"
            type="password"
            placeholder="Required"
            required
          />
        </div>

        <div className="mt-4">
          <label htmlFor="email" className="block text-sm font-bold">
            Referral code
          </label>
          <TextField
            // @ts-ignore
            name="referral"
            type="text"
            placeholder="Optional"
          />
        </div>

        <div className="grid-cols-3 lg:grid mt-14 lg:space-x-9">
          <p className="col-span-2 lg:w-64 text-segments-13px">
            By registering, you agree to our{' '}
            <a
              href="https://tresl.co/terms"
              className="font-bold text-segments-link"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href="https://tresl.co/privacy"
              className="font-bold text-segments-link"
            >
              Privacy Policy
            </a>
          </p>
          <div className="mt-5 lg:mt-0">
            <ButtonCTA variant="main" type="submit" disabled={loading}>
              {loading ? <SpinnerSmall /> : 'Register'}
            </ButtonCTA>
          </div>
        </div>
      </form>
    </div>
  );
}
